import type { AnyAction, ThunkDispatch } from '@reduxjs/toolkit'
import { useDispatch, useSelector } from 'react-redux'

export type FeatureDispatch = ThunkDispatch<unknown, unknown, AnyAction>

export const useFeatureDispatch = useDispatch.withTypes<FeatureDispatch>()
export const useFeatureSelector = useSelector.withTypes<unknown>()
